<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true"
             id="cargando"
             style="z-index: 600;"
             wire:loading
             class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-square-inc-cash</v-icon>
                <p style="color: white;">Recuperaciones</p>


            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row v-if="showTable" justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlHistorial"
                                       :columns="columns"
                                       :params="displayInputs"
                                       :order="[]"
                                       :formatterActions="formatterActions"
                                       @apiDT="apiDT = $event"></DataTable>



                        </v-col>
                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>




<script>
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
    import moment from 'moment'
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
    import Archivos from '@/services/Archivos/Archivos.service.js';

    export default {
        components: {
            DataTable,
            Menu
        },
        data() {
            return {
                showTable: false,
                nombreArchivo: '',
                showcargando: true,
                conclusion: false,
                urlHistorial: "Recuperaciones/ObtenerRecuperaciones",
                displayInputs: {

                },
                apiDT: null,
                columns: [

                    { name: 'nrreporte', data: 'nrreporte', title: "Reporte", formatter: [this, "reporteForm"], },
                    { name: 'd3nombre', data: 'd3nombre', title: "Nombre Tercero", formatter: [this, "terceroForm"], },
                    { name: 'nrmontoneg', data: 'nrmontoneg', title: "Monto Recuperación" },
                    { name: 'nrfhalta', data: 'nrfhalta', title: "Fecha Alta" },
                    { name: 'nrobs', data: 'nrobs', title: "Observaciones" },
                    { name: 'nsfhalta', data: 'nsfhalta', title: "Fecha Movimiento" },
                    { name: 'nsobs', data: 'nsobs', title: "Observaciones Movimiento" },
                    { name: 'dffhpagoestimado', data: 'dffhpagoestimado', title: "Vigencia", formatter: [this, "vigenciaForm"], },
                ],
                formatterActions: [
                    { click: [this, "BuscarDetalleRep"] },
                    { click: [this, "BuscarRecuperaciones"] },
                ],

                listado: '',
                overlay: false,

            }
        },
        computed: {
            ...mapState(["domain", "informationPage", "permission"]),
        },
        methods: {
            async fetchData() {
                const response = this.listado;
                return response;
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },

            async BuscarDetalleRep(params, item, fila) {




                console.log(item);
                let reporte = {
                    nrreporte: item.nrreporte,
                    svindice: item.svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };

                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", item.nrreporte);
                formData.append("svindice", item.svindice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });


                if (ver == 0) {
                    this.$router.push({ name: `${"DatosIncompletos"}` });
                }
                else {

                    let routerName = MetodosGenerales.obtenerRouterName(item.aiclave.toString());

                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    let url = this.$router.resolve({ name: `${routerName}` });

                    window.open(url.href, '_blank');

                }
            },

            async BuscarRecuperaciones(params, item, fila) {

                let reporte = {
                    nrreporte: item.nrreporte,
                    svindice: item.svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion,
                    nrid: item.nrid,
                    nrtippago: item.nrtippago,
                    d3nombre: item.d3nombre,
                };

                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

                this.$router.push({ name: "AltaMovimientosRecuperaciones" });


            },



            reporteForm(datos) {
                if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {

                    return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.nrreporte}-${datos.svindice}</span></button></div>`;
                } else {
                    return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
                }
            },

            terceroForm(datos) {
                return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.d3nombre}</span></button></div>`;
            },

            vigenciaForm(datos) {

                if (datos.dffhpagoestimado == "1") {

                    return ``;
                }
                if (datos.dffhpagoestimado == "3") {

                    return `<div class="ml-4"><span title="A 1 semana de vencer" style="background-color:#F1F90F;" class="dot"></span></div>`;
                }
                if (datos.dffhpagoestimado == "2") {

                    return `<div class="ml-4"><span title="A 1 día de vencer" style="background-color:#FABC08;" class="dot"></span></div>`;
                }
                if (datos.dffhpagoestimado == "4") {

                    return `<div class="ml-4"><span title="Vencido" style="background-color:#F72D0D;" class="dot"></span></div>`;
                }
                if (datos.dffhpagoestimado == "5") {
                    return ``;
                }

                /* return `<div class="ml-4"><span title="value" class="dot"></span></div>`;*/
            },



        },
        async mounted() {

            this.showTable = true;
            this.showcargando = false;

            await MetodosGenerales.verificarPermisoSolo(
                this.domain.domainNameForApi,
                "VerificarPermiso",
                "311"
            ).then((response) => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            });

            await this.reloadTable();





        }
    }
</script>

<style>
    .reporteindice {
        color: var(--v-anchor-base);
    }


    .dot {
        height: 25px;
        width: 25px;
        border-radius: 50%;
        display: inline-block;
    }
</style>

